module.exports = __webpack_public_path__ + "static/album-img1-37e29d2b0bd9c8374954c716c832efc3.jpg";